import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ValidityCounterModal = ({ isOpen, onClose, currentValue, onSubmit }) => {
  const [pickedDate, setPickedDate] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setPickedDate(currentValue ? new Date(currentValue) : null);
    }
  }, [isOpen, currentValue]);

  const handleSubmit = () => {
    if (!pickedDate) return;
    onSubmit(pickedDate.toISOString());
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Set Validity Period Counter</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Validity Period Counter (Jakarta Time)</Label>
          <DatePicker
            selected={pickedDate}
            onChange={setPickedDate}
            showTimeSelect
            timeFormat='HH:mm'
            dateFormat='dd MMM yyyy HH:mm'
            className='form-control'
            placeholderText='Pilih tanggal dan waktu'
            wrapperClassName='d-block'
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={onClose}>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSubmit} disabled={!pickedDate}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ValidityCounterModal;
